import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { ActionValidator, useBaseModules } from '@bonusly/common-action-input';
import { useCurrentCompany } from '@bonusly/who-am-i';

import { Award } from '../../../../../../../types/bonus';
import { useSharedAwardConfig } from './useSharedAwardConfig';

interface UseNonTemplatedAwardConfig {
	onSuccess?: VoidFunction;
}

export const useNonTemplatedAward = (award: Award, options: UseNonTemplatedAwardConfig = {}) => {
	const { t } = useTranslation('recognition');
	const config = useSharedAwardConfig(award, options);
	const company = useCurrentCompany();

	const modules = useBaseModules({
		includeAmount: true,
		includeEmoji: true,
		includeHashtag: true,
		includeLink: true,
		includeMention: true,
		includeRecipient: true,
		includePrivacy: true,
		includeGif: true,
		includeAttachment: true,
		includeVideoRecording: true,
	});

	const validator = useMemo(() => {
		return new ActionValidator({
			requireRecipient: true,
			requirePositiveAmount: !company.zero_point_bonuses,
		});
	}, [company]);

	return {
		context: 'non-templated-award',
		modules,
		placeholder: t('awards.give_modal.input_placeholder_text'),
		validator,
		...config,
	};
};
